import { LAST_DAY, YEAR } from '../constants';

export const isLiveCheck = (talkData, now) => {
  const { startTime: start, endTime: end } = talkData;
  if (start && end) {
    let parsedStart = new Date(`October ${LAST_DAY}, ${YEAR} ${start}:00 GMT+0200`);
    let parsedEnd = new Date(`October ${LAST_DAY}, ${YEAR} ${end}:00 GMT+0200`);
    if (talkData.trackInDay === 6 && talkData.order) {
      const timeframe = 13.3; // lightning talks
      const tmp = parsedStart;
      parsedStart = new Date(tmp.getTime() + (talkData.order - 1) * timeframe * 60000);
      parsedEnd = new Date(tmp.getTime() + talkData.order * timeframe * 60000);
    }
    if (now >= parsedStart && now < parsedEnd) {
      return true;
    }
  }
  return false;
};

export const isConferenceDayCheck = () => {
  const now = new Date();
  if (now.getDate() === LAST_DAY && now.getMonth() === 9) {
    return true;
  }
  return false;
};
